import { Component, OnInit ,Inject,EventEmitter} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '../common.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService } from '../notification.service';
@Component({
  selector: 'app-delete-reason',
  templateUrl: './delete-reason.component.html',
  styleUrls: ['./delete-reason.component.scss']
})
export class DeleteReasonComponent implements OnInit {
  result: any;
  isDeleted = new EventEmitter()
  constructor(@Inject(MAT_DIALOG_DATA) private data:any,private snack:MatSnackBar,private notification:NotificationService,public service:CommonService,public dialog: MatDialog,private router: Router,private dialogRef: MatDialogRef<DeleteReasonComponent>) { }

  ngOnInit(): void {
  }
dltreason(){
  this.service.deletereason(this.data).subscribe((data:any)=>{
    if(data.message == "Success"){
      if(data.message == "Success"){
        // this.snack.open("Deleted successfully",'',{
        //   duration:3000,
        //  verticalPosition:'top',
        //  horizontalPosition: 'end',

        // })
        this.notification.showInfo("Deleted successfully",'')
        // this.router.navigate(['/customer'])
      this.isDeleted.emit(true)
      this.dialogRef.close();
      
    }else{
      alert("something went wrong");
    }
  }
})
}
closeDialog() {
  this.dialogRef.close();
}
}
